/*
 * @Author       : 秦灵
 * @desc         : 组件描述
 * @Date         : 2025-01-14 09:59:54
 * @LastEditTime : 2025-01-14 10:15:41
 * @LastEditors  : 秦灵
 * @FilePath     : /evalute-all/teaching_QualityService/src/store/modules/app.js
 */
const app = {
    state: {
        // 系统配置
        systemInfo: {
            BACKEND_NAME: '',
            BOTTOM_CONTENT: '',
            FRONT_NAME: '',
            RECTANGULAR_DARK_COLOR_LOGO: '',
            RECTANGULAR_TINT_COLOR_LOGO: '',
            SQUARE_DARK_COLOR_LOGO: '',
            SQUARE_TINT_COLOR_LOGO: '',
            TECHNICAL_SUPPORT: '',
            UNIVERSITY_NAME: ''
        }
    },
    mutations: {
        SET_SYSTEM_INFO: (state, config) => {
            state.systemInfo = Object.assign(state.systemInfo, config)
        }
    },
    actions: {
        setSystemInfo({ commit }, config) {
            commit('SET_SYSTEM_INFO', config)
        }
    }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js